import React from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {Card, Image, theme, Typography} from 'antd';
import GaragePlaceholder from 'assets/images/car_placeholder.svg';
import {ImageSkeleton} from 'components/ImageSkeleton';
import {AppRoutePaths} from 'routing/Routes';
import {CarListDto} from '../../../../../../PRMGApiClient';
import {imageErrorCallback} from 'helpers/utils';

interface CarCardProps {
  car: CarListDto;
  garageId: number;
}

export const CarCard: React.FC<CarCardProps> = ({car, garageId}) => {
  const navigate = useNavigate();
  const {t} = useTranslation();
  const {token} = theme.useToken();

  const {
    carId,
    carMakeName,
    carModelName,
    manufactureYear = 0,
    maxSpeed = 0,
    mainPhoto,
    acceleration = 0,
    enginePower = 0,
  } = car;

  return (
    <Card
      hoverable
      cover={
        <div className="overflow-hidden h-52">
          <Image
            height="100%"
            width="100%"
            className="object-cover rounded-lg"
            src={mainPhoto?.url ?? GaragePlaceholder}
            placeholder={<ImageSkeleton />}
            preview={false}
            onError={(e) => mainPhoto && imageErrorCallback(e, mainPhoto)}
          />
        </div>
      }
      onClick={() => navigate(`${AppRoutePaths.garages.url}/${garageId}/vehicles/${carId}`)}
      actions={[
        <div key="maxSpeed" className="car-card-specs-container">
          <Typography.Text strong style={{color: token.blue}}>
            {maxSpeed}
          </Typography.Text>
          <Typography.Text className="text-xs">{t('V-MAX')}</Typography.Text>
        </div>,
        <div key="acceleration" className="car-card-specs-container">
          <Typography.Text strong style={{color: token.blue}}>
            {acceleration}s
          </Typography.Text>
          <Typography.Text className="text-xs">{t('0-100 km/h')}</Typography.Text>
        </div>,
        <div key="enginePower" className="car-card-specs-container">
          <Typography.Text strong style={{color: token.blue}}>
            {enginePower}
          </Typography.Text>
          <Typography.Text className="text-xs">{t('horsepower')}</Typography.Text>
        </div>,
      ]}
    >
      <Card.Meta
        title={
          <div className="flex justify-between">
            <Typography>
              {carMakeName} {carModelName}
            </Typography>
            <Typography.Text type="secondary">{manufactureYear}</Typography.Text>
          </div>
        }
      />
    </Card>
  );
};
